import React, { useEffect } from "react";
import {
  BrowserRouter as Router,
  Routes as Switch,
  Route,
  Navigate as Redirect
} from "react-router-dom";
import Login from "./Auth/Login";
import ForgotPassword from "./Auth/ForgotPassword";
import ResetPassword from "./Auth/ResetPassword";
import Profile from "./Auth/Profile";
import ChangePassword from "./Auth/ChangePassword";
import Dashboard from "./Dashboard/Index";
import User from "./User/Index";
import ReportedUsers from "./ReportedUsers";
import ApplicationSetting from "./ApplicationSetting/Index";
import FAQ from "./Faq/Index";
import FAQAdd from "./Faq/Add";
import FAQEdit from "./Faq/Edit";
import Content from "./Content/Index";
import ContentEdit from "./Content/Edit";
import NotFound from "../NotFound";
import Helper from "../../Helper";

function AdminRoutes() {

  const Logout = () => {
    Helper.removeStorageData()
    return (<Redirect to={window.constants.admin_login_url} />)
  }

  return (
    <Router>
      <Switch>
        <Route
          path={"/login/zekkmdvhkm"}
          element={<Login />}
        />
        <Route
          path={"/forgot-password/zekkmdvhkm"}
          element={<ForgotPassword />}
        />
        <Route
          path={"/reset-password/:token"}
          element={<ResetPassword />}
        />
        <Route
          path={"/profile"}
          element={<Profile />}
        />
        <Route
          path={"/change-password"}
          element={<ChangePassword />}
        />
        <Route
          path={"/"}
          element={<User />}
        />
        <Route
          path={"/dashboard"}
          element={<User />}
        />
        <Route
          path={"/users"}
          element={<User />}
        />
        <Route
          path={"/reported-users"}
          element={<ReportedUsers />}
        />
        <Route
          path={"/application-setting"}
          element={<ApplicationSetting />}
        />
        <Route
          path={"/faq"}
          element={<FAQ />}
        />
        <Route
          path={"/faq/add"}
          element={<FAQAdd />}
        />
        <Route
          path={"/faq/edit/:slug"}
          element={<FAQEdit />}
        />
        <Route
          path={"/content"}
          element={<Content />}
        />
        <Route
          path={"/content/edit/:slug"}
          element={<ContentEdit />}
        />
        <Route
          path="/*" element={<NotFound />} />
      </Switch>
    </Router>
  );
}
export default React.memo(AdminRoutes)
